module.exports = __webpack_public_path__ + "img/1.54e9155d.png";